import { c as _c } from "react/compiler-runtime";
import { Avatar, Box, Button, Center, HStack, Heading, Icon, Image, Stack, Text, VStack, Separator } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { MdVerified } from 'react-icons/md';
import { SiTrustpilot } from 'react-icons/si';
interface TrustPilotCardProps {
  personFullName?: string;
  personFirstName?: string;
  personLastName?: string;
  personAvatarUrl?: string;
  reviewTitle?: string;
  starsDecimal?: string;
  quote?: string;
  bgColor?: string;
  bgGradient?: string;
}
const TrustPilotCard: React.FC<TrustPilotCardProps> = t0 => {
  const $ = _c(35);
  const {
    personFullName,
    personFirstName,
    personLastName,
    personAvatarUrl,
    reviewTitle,
    quote,
    bgColor,
    bgGradient
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Center bgColor="#00B67A" padding={1}><SiTrustpilot size={12} /></Center>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Center bgColor="#00B67A" padding={1}><SiTrustpilot size={12} /></Center>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Center bgColor="#00B67A" padding={1}><SiTrustpilot size={12} /></Center>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Center bgColor="#00B67A" padding={1}><SiTrustpilot size={12} /></Center>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HStack gap={0.5}>{t1}{t2}{t3}{t4}<Center bgColor="rgba(0, 182, 122, 0.2)" padding={1} position="relative"><Icon asChild={true} boxSize={3} zIndex={2}><SiTrustpilot /></Icon><Box bgColor="#00B67A" height="full" left={0} position="absolute" top={0} width="50%" zIndex={1} /></Center></HStack>;
    t6 = <Separator />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== getBreakpointValue || $[7] !== personAvatarUrl) {
    t7 = personAvatarUrl ? <Avatar.Root boxShadow="base" size={getBreakpointValue(["md", "md"])}><Avatar.Fallback /><Avatar.Image src={personAvatarUrl} /></Avatar.Root> : undefined;
    $[6] = getBreakpointValue;
    $[7] = personAvatarUrl;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== getBreakpointValue) {
    t8 = getBreakpointValue(["lg", "xl"]);
    $[9] = getBreakpointValue;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = personFullName ? personFullName : `${personFirstName} ${personLastName}`;
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <VStack align="flex-start" gap={0}><Text fontSize={t8} textStyle="labelLg">{t9}</Text></VStack>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t7) {
    t11 = <Stack align="center" direction="row" gap={4}>{t5}{t6}<HStack align="center" gap={4} width="full">{t7}{t10}</HStack></Stack>;
    $[14] = t10;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== reviewTitle) {
    t12 = <Heading fontWeight={600} lineHeight="shorter" size="lg">{reviewTitle}</Heading>;
    $[17] = reviewTitle;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== quote) {
    t13 = <Text color="textPrimaryAlpha.800" fontSize="md">{quote}</Text>;
    $[19] = quote;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12 || $[22] !== t13) {
    t14 = <VStack align="flex-start" gap={4}>{t12}{t13}</VStack>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t11 || $[25] !== t14) {
    t15 = <VStack align="flex-start" alignSelf="stretch" gap={8} height="full" padding={8}>{t11}{t14}</VStack>;
    $[24] = t11;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Image src="/assets/graphics/trustpilot.svg" width={24} />;
    t17 = <Separator />;
    $[27] = t16;
    $[28] = t17;
  } else {
    t16 = $[27];
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <HStack align="center" gap={3} width="full">{t16}{t17}<HStack gap={2}><HStack gap={0.5}><Center bgColor="#00B67A" padding={1}><Icon asChild={true} boxSize="0.6em" zIndex={2}><SiTrustpilot /></Icon></Center></HStack><Text textStyle="labelSm">4.8</Text></HStack></HStack>;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Stack align="center" bgColor="black" boxShadow="lg" direction="row" justify="space-between" padding={6} width="full">{t18}<Button bgColor="#00B67A35" paddingLeft={3} paddingRight={4} size="xs"><MdVerified color="#00B67A" size="1.5em" /><Text textStyle="badgeXs">Verified</Text></Button></Stack>;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== bgColor || $[32] !== bgGradient || $[33] !== t15) {
    t20 = <Stack align="flex-start" bg={bgGradient} bgColor={bgColor} borderRadius="2xl" boxShadow="sm" overflow="hidden" width="full">{t15}{t19}</Stack>;
    $[31] = bgColor;
    $[32] = bgGradient;
    $[33] = t15;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  return t20;
};
export default TrustPilotCard;